/* eslint-disable react/require-default-props */
import React from 'react';
import dayjs from 'dayjs';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ServiceTime } from '../../../utils/types/ProjectType';
import { weekDaysIndex } from '../../../helpers/weekDays';

interface Props {
  data: ServiceTime;
}

const sortDays = (days: string[]): string[] => {
  return days
    ?.slice()
    ?.sort((a, b) => (weekDaysIndex[a] ?? 7) - (weekDaysIndex[b] ?? 7));
};

const ServicesSetup: React.FC<Props> = function ServicesSetup({ data }) {
  const { t } = useTranslation();
  const sortedDays = sortDays(data?.frequencyDays || []);

  const fields = [
    {
      label: t('TOOLTIP.PROJECT.serviceFrequency'),
      value: data.frequency || 'N/A'
    },
    {
      label: t('TOOLTIP.PROJECT.startDate'),
      value: dayjs(data.startDate || 'N/A').format('DD-MM-YYYY')
    },
    {
      label: t('TOOLTIP.PROJECT.daysOfWeek'),
      value:
        sortedDays.length > 1 ? sortedDays.join(' - ') : sortedDays[0] || 'N/A'
    },
    { label: t('TOOLTIP.PROJECT.travelTime'), value: data.travelTime || 'N/A' },
    {
      label: t('TOOLTIP.PROJECT.endDate'),
      value: dayjs(data.endDate || 'N/A').format('DD-MM-YYYY')
    }
  ];

  return (
    <Box
      sx={{
        backgroundColor: '#FAFBFC',
        borderTop: '1px solid #E2E4EA',
        display: 'flex',
        flexWrap: 'wrap',
        gap: '12px 32px',
        px: 2,
        py: 1.5,
        width: '100%'
      }}
    >
      {fields.map(({ label, value }) => (
        <Box
          key={label}
          sx={{ alignItems: 'center', display: 'flex', gap: '6px' }}
        >
          <Typography
            sx={{ color: '#7D8090', fontSize: '11px', fontWeight: 500 }}
          >
            {label}:
          </Typography>
          <Typography
            sx={{ color: '#0f1c2e', fontSize: '12px', fontWeight: 700 }}
          >
            {value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export default ServicesSetup;
